
<template>
  <transition name="fade">
    <div
      v-show="showSlider===true"
      class="modal is-active"
    >
      <div class="modal-background" />
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-title has-text-centered">
            <button
              v-if="showNewWindow"
              class="button is-primary is-broad is-uppercase"
              @click="openNewWindow"
            >
              Open in New Window
            </button>
          </div>
          <button
            v-if="closeButton"
            class="delete is-default float-right close-x"
            aria-label="close"
            @click="$emit('close')"
          />
        </header>
        <section class="modal-card-body">
          <div
            style="z-index:102;width:95%;"
            class="modal-custom-body"
          >
            <vue-slick-carousel
              ref="slick"
              v-bind="slickOptions"
            >
              <div
                v-for="item in imageList"
                :key="item.id"
              >
                <div
                  class="image-container"
                  :style="{'backgroundImage': 'url(' +item.src + ')'}"
                />
                <div
                  class="is-size-5 text-container"
                  v-html="item.text"
                />
              </div>
            </vue-slick-carousel>
          </div>
        </section>
        <footer class="modal-card-foot" />
      </div>
    </div>
  </transition>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'CarouselModal',
  components: {
    VueSlickCarousel
  },
  props: {
    showSlider: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    showNewWindow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      openDelay: false,
      slickOptions: {
        dots: true,
        autoplay: false,
        infinite: false,
        accessibility: true,
        adaptiveHeight: false,
        arrows: true,
        draggable: true,
        edgeFriction: 0.3,
        swipe: true,
        center: true,
        dontAnimate: true,
        fade: true
      },
      imageList: [
        {
          id: 0,
          src: require('../../assets/slider/Slide1.png'),
          text:
            'Welcome to the Website Builder getting started guide. Follow these simple steps to get your site up and running. Click the button at the top to open this slideshow in a new window so we can guide you step by step. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 1,
          src: require('../../assets/slider/Slide2.png'),
          text:
            'Hit view profile on the left hand side. Simply enter your business information – don’t worry your name won’t appear on your website – then click save. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 2,
          src: require('../../assets/slider/Slide3.png'),
          text:
            'Using the options at the top of the screen, select Address and enter your details. If you don’t want this to appear on your website just click “hide address” - then click save. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 3,
          src: require('../../assets/slider/Slide4.png'),
          text:
            'Now select Contact and fill in your business information. If you have a website you want to promote, you can enter it here too – then click save. Now click “Dashboard” <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 4,
          src: require('../../assets/slider/Slide5.png'),
          text:
            'Now that your business profile is done, you need to choose a domain name for your website. Hit “Configure Your Domain” <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 5,
          src: require('../../assets/slider/Slide6.png'),
          text:
            'If you want a new domain click "Register domain name" and go to the next slide, If you want to assign an existing domain, skip the next section and go to slide 10 (Open Domain Instructions)<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 6,
          src: require('../../assets/slider/Slide7.png'),
          text:
            'Website Builder includes a handy domain picker, so you can enter your business name (or anything you like) and we’ll let you know what’s available. <strong>Tip, make it short, memorable and easy to spell – just like BT.com</strong><br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 7,
          src: require('../../assets/slider/Slide8.png'),
          text:
            'We need to register the domain name before you can use it – so need a few extra details to do this – but we’ve remembered what you’ve already entered! Complete the extra information and click register domain. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 8,
          src: require('../../assets/slider/Slide9.png'),
          text:
            'Once you have chosen your Domain, assign it to your Website by ticking the box.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 9,
          src: require('../../assets/slider/Slide10.png'),
          text:
            'Click Open Domain instructions and make sure your domain DNS settings are right.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 10,
          src: require('../../assets/slider/Slide11.png'),
          text:
            'Our DNS guide gives you the information you need to update your DNS for your domain name. If our instructions don’t cover your provider please ask them direct how to change the DNS.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 11,
          src: require('../../assets/slider/Slide12.png'),
          text:
            'Once you have the DNS set up right, you can Assign the domain by entering it and submitting. This will then attach the domain to your account.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 12,
          src: require('../../assets/slider/Slide13.png'),
          text:
            'Now the interesting stuff. You might have noticed Template Picker has appeared in the dashboard. Click that now. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 13,
          src: require('../../assets/slider/Slide14.png'),
          text:
            'There are plenty of Templates to choose from, so have a good look see which fits your business best. Each template has a single or multi page option too. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 14,
          src: require('../../assets/slider/Slide15.png'),
          text:
            'There will be a "PENDING" button for a short while until we prepare your subscription. When the template is ready to pick the button will change to say "SELECT TEMPLATE" <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 15,
          src: require('../../assets/slider/Slide16.png'),
          text:
            'The My Website section has appeared in the dashboard – click edit my website. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 16,
          src: require('../../assets/slider/Slide17.png'),
          text:
            'Now you are in the Website Builder editor. Hover over your chosen template and you will see the EDIT option appear. Click this now. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 17,
          src: require('../../assets/slider/Slide18.png'),
          text:
            'Click Get Started. Website Builder will take you through an interactive journey to show you how to build the perfect website. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 18,
          src: require('../../assets/slider/Slide19.png'),
          text:
            'Over to you, time to make it your own! You can publish a simple website to get your company online, and add to it over time. <br><br><strong>If you need help at any time, click HELP on the bottom right corner.</strong>'
        },
        {
          id: 19,
          src: require('../../assets/slider/Slide20.png'),
          text:
            'Activate online store is now included in the My Website section. When you are ready to add a store to your website click activate online store.'
        }
      ]
    }
  },
  watch: {
    showSlider: {
      handler (newVal, oldVal) {
        this.$refs.slick.goTo(0)
      }
    }
  },
  methods: {
    openNewWindow () {
      const routeData = this.$router.resolve({ name: 'btTourNewWindow' })
      window.open(routeData.href, '_blank')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
// for transition fade
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modal-card-head {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 5px;
}

.modal-card {
  position: relative;
  transition: top 0.3s;
  top: 0;
}

.modal-card {
  width: 90%;
}

.modal-wrapper {
  z-index: 40;
}

.modal {
  z-index: 300;
}

.modal-background {
  opacity: 0.6;
}

.modal-card-head,
.modal-card-foot,
.modal-card-body {
  background-color: white;
  border: none;
}

.modal-card-body {
  color: var(--primary-color);
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.modal-card-foot {
  justify-content: flex-end;

  @media screen and (max-width: 400px), print {
    .button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

.image-container {
  width: 100%;
  height: 200px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.text-container {
  margin-top: 10px;
  height: 250px;
  width: 100%;
  margin-bottom: 4px;
}

@media only screen and (min-width: 600px) {
  .text-container {
    height: 98px;
  }

  .image-container {
    width: 93%;
    height: 380px;
    margin: auto;
  }

  .modal-card-foot {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

@media only screen and (max-height: 400px) {
  .image-container {
    width: 93%;
    height: 170px;
  }
}
@media only screen and (min-width: 991px) {
  .modal-card {
    width: 800px;
  }

  .text-container {
    height: 63px;
  }

  .image-container {
    width: 97%;
    height: 380px;
    margin: auto;
  }

  .text-container {
    height: 40%;
  }

  .modal-card-foot {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .close-x {
    margin-bottom: 11px;
  }
}
</style>
<style lang="scss">
.slick-next::before,
.slick-prev::before {
  color: var(--primary-color) !important;
}

.slick-dots li button::before {
  width: 7px;
  height: 7px;
  display: block;
  margin: 5px 5px;
  border: 1px solid var(--primary-color);
  border-radius: 30px;
  opacity: 1;
  color: transparent;
  content: "";
}

.slick-dots li.slick-active button::before {
  background-color: var(--primary-color);
  color: var(--primary-color);
  border-radius: 30px;
  opacity: 1;
  color: transparent;
  content: "";
}
</style>
